var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mcs-btn',{staticClass:"ml-2",attrs:{"small":"","color":"accent","prepend-icon":_vm.expanded ? 'mdi-arrow-collapse-all' : 'mdi-arrow-expand-all'},on:{"click":_vm.expand}},[_vm._v(" "+_vm._s(_vm.expanded ? 'Collapse' : 'Expand')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }